import React, { useEffect, useState } from 'react'
import { Button, Col, Divider, Drawer, Input, message, Row, Typography, Radio } from 'antd'

const { Title } = Typography

function PaisDrawer(props) {
  const [name, setName] = useState('')
  const [abbreviation, setAbbreviation] = useState('')
  const [symbol, setSymbol] = useState('')
  const [description, setDescription] = useState('')
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setName(props.edit ? props.editData.name : '')
    setAbbreviation(props.edit ? props.editData.abbreviation : '')
    setSymbol(props.edit ? props.editData.symbol : '')
    setDescription(props.edit ? props.editData.description : '')
    setDisabled(props.edit ? (props.editData.disabled === 1 ? true : false) : false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible])

  const onSaveButton = () => {
    if ([name, abbreviation, symbol, description].includes('') || [name, abbreviation, symbol, description].includes(null)) {
      return message.warning('Todos los campos son obligatorios')
    }
    const data = {
      name: name,
      abbreviation: abbreviation,
      symbol: symbol,
      description: description,
      disabled: disabled
    }
    props.saveButton(props.edit, data, props.edit ? props.editData.id : null)
  }

  return (
    <>
      <Drawer placement="right" closable={false} onClose={props.closable} visible={props.visible} width={800}>
        <div className={'products-container-combo-tabs'}>
          <Title> {props.edit ? 'Editar moneda' : 'Nueva moneda'} </Title>
          <Divider className={'divider-custom-margins-users'} />
          {/*Fields section*/}
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Nombre*</div>
              <Input value={name} onChange={value => setName(value.target.value)} placeholder={'Nombre moneda'} size={'large'} />
            </Col>

            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Abreviacion*</div>
              <Input value={abbreviation} onChange={value => setAbbreviation(value.target.value)} placeholder={'Abreviacion moneda'} size={'large'} />
            </Col>
          </Row>
          <Row gutter={16} className={'section-space-field'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Simbolo*</div>
              <Input value={symbol} onChange={value => setSymbol(value.target.value)} placeholder={'Simbolo moneda'} size={'large'} />
            </Col>

            <Col xs={12} sm={12} md={12} lg={12}>
              <div className={'title-space-field'}>Descripcion*</div>
              <Input value={description} onChange={value => setDescription(value.target.value)} placeholder={'Descripcion moneda'} size={'large'} />
            </Col>
          </Row>

          <Row gutter={16} className={'section-space-list'}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <span className={'label-bold-500 ratio-button-labels'}>¿Moneda en funcionamiento?</span>
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Radio.Group
                className={'radio-group'}
                optionType="button"
                buttonStyle="solid"
                size={'large'}
                value={disabled}
                onChange={value => setDisabled(value.target.value)}
              >
                <Radio.Button value={false}>No</Radio.Button>
                <Radio.Button value={true}>Sí</Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
          {/*End Fields section*/}
        </div>
        <Divider className={'divider-custom-margins-users'} />
        {/*Footer buttons section*/}
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24} lg={24}>
            <div className="text-right">
              <div>
                <Button type={'link'} className="cancel-button" onClick={() => props.cancelButton()}>
                  Cancelar
                </Button>
                <Button htmlType="submit" className="title-tendero new-button" onClick={() => onSaveButton()}>
                  Guardar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        {/*End Footer buttons section*/}
      </Drawer>
    </>
  )
}

export default PaisDrawer
